import { Formatters, Messages } from '../../gen-src/Localize';
import { TextAreaProps } from '../widgets/TextAreaWidget';

export type TextValidationProps = Pick<TextAreaProps, 'valid' | 'message'>;

/**
 * A function which returns a localized validation message and state for character count validation
 * @param current the current value (or length) of the string to validate
 * @param maximum the maximum number of characters allowed
 */
export function getMaxCharValidation(current: string | number, maximum: number): TextValidationProps {
  const currentLength = typeof current === 'string' ? current.length : current;

  return {
    valid: currentLength > maximum ? false : undefined, // design calls for no green border, so 'valid' is just grey (undefined)
    message: Messages.characterCount({ COUNT: Formatters.formatCount(currentLength), MAXIMUM: Formatters.formatCount(maximum) }),
  }
}
